module.exports = __webpack_public_path__ + "img/4cd94fc.jpg";